export const getRouteForPersonaListScreen = (currentPath = "", selectedPersona = "", selectedGroupIds = []) => {
    const params = new URLSearchParams();
    if (selectedPersona) {
      params.append("persona", selectedPersona);
    }
    selectedGroupIds.forEach(id => params.append("department", id));
    const queryString = params.toString();
    return queryString ? `${currentPath}?${queryString}` : currentPath;
  };
  